export const metatagirodzajofert = {
  Page: {
    "meta-tagi": {
      Title: "Rodzaje wczasów i wakacji, oferty wyjazdów - SkiOne.pl",
      Description:
        "Rodzaje wczasów i wakacji - SkiOne.pl - sprawdź oferty hoteli oraz rodzaje wczasów narciarskich - najlepsze hotele polecane przez naszych Klientów.::: Zaplanuj idealne wakacje i ferie z Grupą Portali TravelOne.pl i SkiOne.pl!",
      Keywords: []
    }
  }
};
